import { useRouter } from "next/navigation";
import { CiCalendar, CiLocationOn } from "react-icons/ci";

import Headline from "@/partials/elements/Headline";
import ShortInfoFlex from "./ShortInfoFlex";
import Description from "@/partials/elements/Description";
import ViewAll from "@/partials/elements/ViewAll";

export default function EventCardInfo({ item }) {
  const router = useRouter();
  const dateString = item.dateString;
  const eventDate = new Date(dateString);

  const formattedDateStringPast = eventDate.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "2-digit",
  });

  return (
    <div className="flex-1 ">
      <Headline
        text={item.title}
        extraClass={
          "text-[#21272A] md:text-[28px] group-hover:text-primary duration-300"
        }
      />

      <ShortInfoFlex>
        <CiLocationOn className="text-lg" />
        <Description text={item.location} extraClass={"pb-0 lg:pb-0"} />
      </ShortInfoFlex>

      <ShortInfoFlex>
        <CiCalendar className="text-[18px]" />
        <Description
          text={formattedDateStringPast}
          extraClass={"pb-0 lg:pb-0"}
        />
      </ShortInfoFlex>

      <Description
        text={item.shortDescription}
        extraClass={"pb-0 lg:pb-0 mt-6"}
      />

      <ViewAll
        action={() => router.push(`/events/eventDetails/${item?._id}`)}
        text={"Read More"}
        extraClass={"mt-6 "}
      />
    </div>
  );
}
